import { type ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import classNames from '@/utils/classnames';

interface SidebarShellProps {
  /** The left sidebar (e.g. <AppSidebar/> or <AdminSidebar/>). */
  sidebar: ReactNode;
  /** Main content. Defaults to the routed <Outlet/> when omitted. */
  children?: ReactNode;
  mainClassName?: string;
}

/**
 * Shared app shell — a persistent sidebar plus a rounded "main card" floating on
 * the sunken canvas. Used by both the team app shell and the admin panel so they
 * share one layout/chrome. Matches the Zooid "Deep Space" design.
 */
export function SidebarShell({ sidebar, children, mainClassName }: SidebarShellProps) {
  return (
    <div className="flex h-screen overflow-hidden bg-sunken">
      {sidebar}
      <main
        className={classNames(
          'my-3 ml-2.5 mr-3 min-w-0 flex-1 overflow-hidden rounded-2xl border border-line bg-surface-1 shadow-(--shadow-card)',
          mainClassName,
        )}
      >
        <div className="flex h-full flex-col">{children ?? <Outlet />}</div>
      </main>
    </div>
  );
}
